import request from '../kernel/request'

export default {
	payDetail: {
		list(params) {
			return request.get('payDetail/list', params)
		},
		stat(params) {
			return request.get('payDetail/stat', params)
		},
		statistics(params) {
			return request.get('payDetail/statistics', params)
		},
		statList(params) {
			return request.get('payDetail/stat/list', params)
		},
		statDay(params) {
			return request.get('payDetail/stat/day', params)
		},
		home(params) {
			return request.get('payDetail/home', params)
		},
		loadByMemberId(id) {
			return request.get('payDetail/list/member/' + id)
		},
		listByRecordDetailId(id) {
			return request.get('payDetail/record/detail/' + id)
		},
		stampList(id) {
			return request.get('payDetail/record/stamp/' + id)
		},
		loadByRecordDetailId(id) {
			return request.get('payDetail/list/recordDetail/' + id)
		},
		save(data) {
			return request.post(`payDetail`, data)
		},
		update(data) {
			return request.put(`payDetail`, data)
		},
		delete(id) {
			return request.delete('payDetail/' + id)
		},
		load(id) {
			return request.get('payDetail/' + id)
		},
		refund(id) {
			return request.get('payDetail/refund/' + id)
		}
	},
	recordDetail: {
		list(params) {
			return request.get('payRecordDetail/list', params)
		},
		loadByMemberId(id) {
			return request.get('payRecordDetail/list/member/' + id)
		},
		loadByRecordId(id) {
			return request.get('payRecordDetail/list/record/' + id)
		},
		save(data) {
			return request.post(`payRecordDetail`, data)
		},
		update(data) {
			return request.put(`payRecordDetail`, data)
		},
		send(data) {
			return request.put(`payRecordDetail/send`, data)
		},
		delete(id) {
			return request.delete('payRecordDetail/' + id)
		},
		load(id) {
			return request.get('payRecordDetail/' + id)
		},
		statByWay(params) {
			return request.get('payRecordDetail/stat/way', params)
		}
	},
	debt: {
		list(params) {
			return request.get('debt/list', params)
		},
		stat(params) {
			return request.get('debt/stat', params)
		},
		save(data) {
			return request.post(`debt`, data)
		},
		update(data) {
			return request.put(`debt`, data)
		},
		delete(id) {
			return request.delete('debt/' + id)
		},
		load(id) {
			return request.get('debt/' + id)
		},
		waitList(params) {
			return request.get('debt/wait', params)
		},
		outList(params) {
			return request.get('debt/out', params)
		},
		noTimeList(params) {
			return request.get('debt/noTime', params)
		}
	},
	paymentRecord: {
		list(params) {
			return request.get('paymentRecord/list', params)
		},
		deleteList(params) {
			return request.get('paymentRecord/deleteList', params)
		},
		debt(params) {
			return request.get('paymentRecord/debt', params)
		},
		stat(params) {
			return request.get('paymentRecord/stat', params)
		},
		sumGroup(params) {
			return request.get('paymentRecord/sumGroup', params)
		},
		save(data) {
			return request.post(`paymentRecord/insert/pay`, data)
		},
		update(data) {
			return request.put(`paymentRecord`, data)
		},
		upSpecialty(id, data) {
			return request.put(`paymentRecord/upSpecialty/` + id, data)
		},
		upDelete(id) {
			return request.get(`paymentRecord/upDelete/` + id)
		},
		delete(id) {
			return request.delete('paymentRecord/' + id)
		},
		isDelete(id) {
			return request.delete('paymentRecord/isDelete/' + id)
		},
		load(id) {
			return request.get('paymentRecord/' + id)
		},
		loadDetail(id) {
			return request.get('paymentRecord/detail/' + id)
		},
		loadByMemberId(id, params) {
			return request.get('paymentRecord/load/member/' + id, params)
		},
		repayment(data) {
			return request.post('paymentRecord/insert/repayment', data)
		},
		refund(data) {
			return request.post('paymentRecord/insert/refund', data)
		},
		groupCase(data) {
			return request.get('paymentRecord/group/case', data)
		},
		leadPay: `${request.baseURL}/lead/excel`,
	},
	projectInput: {
		list(params) {
			return request.get('project/input', params)
		},
		page(params) {
			return request.get('project/input/page', params)
		},
		sumBy(params) {
			return request.get('project/input/sumBy', params)
		},
		save(data) {
			return request.post(`project/input/save`, data)
		},
		update(data) {
			return request.put(`project/input`, data)
		},
		delete(id) {
			return request.delete('project/input/' + id)
		},
		load(id) {
			return request.get('project/input/' + id)
		},
		loadBy(id) {
			return request.get('project/input/loadBy/' + id)
		},
		uploadUrl: `${request.baseURL}/project/input/uploadLic`,
		uploadAttachment: `${request.baseURL}/project/input/uploadAttachment`
	},
	protocol: {
		list(params) {
			return request.get('protocol', params)
		},
		page(params) {
			return request.get('protocol/page', params)
		},
		save(data) {
			return request.post(`protocol/save`, data)
		},
		check(data) {
			return request.put(`protocol/check`, data)
		},
		update(data) {
			return request.put(`protocol`, data)
		},
		updateUrl(data) {
			return request.put(`protocol/update`, data)
		},
		delete(id) {
			return request.delete('protocol/' + id)
		},
		load(id) {
			return request.get('protocol/' + id)
		},
		uploadUrl: `${request.baseURL}/protocol/uploadLic`
	},
	proof: {
		list(params) {
			return request.get('proof', params)
		},
		page(params) {
			return request.get('proof/page', params)
		},
		save(data) {
			return request.post(`proof/save`, data)
		},
		update(data) {
			return request.put(`proof`, data)
		},
		check(data) {
			return request.put(`proof/check`, data)
		},
		updatePay(data) {
			return request.put(`proof/pay/update`, data)
		},
		updateSc(data) {
			return request.put(`proof/update`, data)
		},
		delete(id) {
			return request.delete('proof/' + id)
		},
		load(id) {
			return request.get('proof/' + id)
		},
		loadBy(id) {
			return request.get('proof/load/' + id)
		},
		uploadUrl: `${request.baseURL}/proof/uploadLic`
	},
	photo: {
		list(params) {
			return request.get('photo', params)
		},
		page(params) {
			return request.get('photo/page', params)
		},
		save(data) {
			return request.post(`photo/save`, data)
		},
		update(data) {
			return request.put(`photo`, data)
		},
		delete(id) {
			return request.delete('photo/' + id)
		},
		load(id) {
			return request.get('photo/' + id)
		},
		loadBy(id) {
			return request.get('photo/loadBy/' + id)
		},
		uploadUrl: `${request.baseURL}/photo/uploadLic`
	},
	// paymentDetail:{
	//     list(params) {
	//         return request.get('paymentDetail', params)
	//     },
	//
	//     save(data) {
	//         return request.post(`paymentDetail/insert/list`, data)
	//     },
	//     update(data) {
	//         return request.put(`paymentDetail`, data)
	//     },
	//     delete(id) {
	//         return request.delete('paymentDetail/'+id)
	//     },
	//     load(id) {
	//         return request.get('paymentDetail/' + id)
	//     }
	// },
}